// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spinner, Flex } from '@chakra-ui/react';

const ProtectedRoute = () => {
    const { user, initialising } = useAuth();

    // While loading the user state, you might want to return a loading spinner
    if (initialising) {
        return (
            <Flex justify="center" align="center" minH="100vh">
                <Spinner size="xl" />
            </Flex>
        );
    }

    // If no user, redirect them to the login page
    return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;